import classes from "./index.module.css";
import TooltipIcon from "@/components/TooltipIcon";
import { PropsWithChildren } from "react";
import { MantineSize } from "@mantine/core";

interface ControlsWrapperProps extends PropsWithChildren {
  helperLabel?: string;
  size?: MantineSize | (string & NonNullable<unknown>);
}

export const ControlsWrapper = ({ helperLabel = "", size, children }: ControlsWrapperProps) => {
  return (
    <span className={classes.wrapper}>
      {children}
      {helperLabel && (
        <span className={classes.tooltipIconWrapper}>
          <TooltipIcon label={helperLabel} size={size === "md" ? 32 : 24} />
        </span>
      )}
    </span>
  );
};
